module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-product"
  }, [_c('p', {
    staticClass: "search-count"
  }, [_vm._v("找到" + _vm._s(_vm.goods_count) + "条搜索结果")]), _vm._v(" "), _c('product')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fca1ada","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/Product.vue
// module id = 793
// module chunks = 0